module.exports = __webpack_public_path__ + "static/media/empty_yellow.91c97e1b.PNG";